import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './settings-dialog.controller';
import template from './settings-dialog.html';


class dialogService {
  getOptions($event, locals) {
    return {
      controller,
      controllerAs: 'settingsDialogVM',
      locals,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event, // <-- Only keep if required
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.settingsDialog', [
  alerts,
  constants,
  ecatDataService,
  loaderService,
  ssDialogService,
  userService,
])
  .service('ecatSettingsDialog', dialogService)
  .name;
